import { MerchantStatus } from '@nemuru-eng/js-api-client';

export const ALLOWED_MERCHANT_STATUSES_FOR_MULTI_SELECT_FILTER = [
  MerchantStatus.STATUS_DOCUMENTS_COMPLETED,
  MerchantStatus.STATUS_PENDING_DOCUMENTS,
  MerchantStatus.STATUS_PRE_APPROVED,
  MerchantStatus.STATUS_DENIED_EVALUATED,
  MerchantStatus.STATUS_SUSPENDED,
  MerchantStatus.STATUS_BANNED,
  MerchantStatus.STATUS_DENIED_PENDING_MANUAL,
  MerchantStatus.STATUS_ASLEEP,
];
